export const formatNumber = (
  number: number | string,
  minimumFractionDigits?: number
) => {
  return new Intl.NumberFormat("en-US", { minimumFractionDigits }).format(
    Number(number)
  );
};
